import { startTransition } from "react";
import { useNavigate } from "react-router-dom";
import { useDialog } from "@shared/features/dialog/useDialog";
import { OptionType } from "@shared/ui/Select";
import { OrganizationType } from "@platform/types/orgInvitation.types";
import { orgInvitationEventBus } from "../../orgInvitation.events";
import {
  INVITATION_SET,
  usePlatformDispatch,
} from "@platform//PlatformContext";
import { useValidateOrgLookupItem } from "../../hooks/useValidateLookupOrg";
import OrgLookupItem from "./OrgLookupItem";

export function OrgLookupItemContainer({ label, data }: OptionType) {
  const dispatch = usePlatformDispatch();

  const { closeDialog } = useDialog();

  const navigate = useNavigate();

  const {
    isLoading,
    isValid,
    data: validatedData,
  } = useValidateOrgLookupItem(data);

  const handleJoinClick = (organization: OrganizationType) => {
    orgInvitationEventBus.emitEvent("lookupOrg:joinIntent", { organization });

    closeDialog("orgLookup");

    startTransition(() => {
      dispatch({ type: INVITATION_SET, payload: validatedData });

      setTimeout(() => {
        navigate("/enroll");
      }, 100);
    });
  };

  const handleInviteOrg = (organization: OrganizationType) => {
    orgInvitationEventBus.emitEvent("lookupOrg:inviteIntent", { organization });

    navigate("/invite-institution");
  };

  return (
    <OrgLookupItem
      handleJoinClick={() => handleJoinClick(data)}
      handleInviteOrg={() => handleInviteOrg(data)}
      isLoading={isLoading}
      isValid={isValid}
      isNew={data.created}
      label={label}
    />
  );
}

export default OrgLookupItemContainer;
